/**
 *
 * Header.js
 *
 * bladsfasdfas
 */
import React, { Children } from 'react';
import Wrapper from './Wrapper';
import iPhoneX from '../../image/roi/iPhone-X-Mockup.png';

function AdPreview(props) {

    let { currentApp, secondApp, searchTerm } = props;
    return (
        <Wrapper>
          <div className="exampleAdPreview">
            { "广告预览" }
          </div>
          
          <div className="exampleHolder">
            <div className="adExample__ad-example adExampleFull__ad-example">
              <img
                className="iPhone"
                src={process.env.PUBLIC_URL + iPhoneX}
              />
              
              <div className="searchTerm__ad-example">
                { searchTerm }
              </div>
              
              <div className="container__ad-example">
                <div className="app__ad-example isAd__ad-example">
                  <div className="appSummary__ad-example">
                    <div className="appThumbnail__ad-example">
                      <img src={ currentApp.artworkUrl100 } alt={ "appIcon" } />
                    </div>
                    
                    <div className="appDetail__ad-example">
                      <div className="appName__ad-example">
                        { currentApp.trackCensoredName }
                      </div>
                      
                      <div className="publisher__ad-example">
                        <span>
                          <span className="adSymbol__ad-example">Ad</span>
                          
                          { currentApp.sellerName }
                        </span>
                      </div>
                    </div>
                    
                    <span className="getButton__ad-example">
                      { "GET" }
                    </span>
                  </div>
                  
                  <div className="screenshotsContainer__ad-example">
                    {
                      currentApp.screenshotUrls.slice(0, 3).map( ( url, index) => 
                        <div className="screenshot__ad-example" key={index}>
                          <img src={ url } alt={ "screen" }/>
                        </div>
                      )
                    }
                  </div>
                </div>
                
                <div className="app__ad-example">
                  <div className="appSummary__ad-example">
                    <div className="appThumbnail__ad-example">
                      <img src={ secondApp.artworkUrl100 } alt={ "appIcon" } />
                    </div>
                    
                    <div className="appDetail__ad-example">
                      <div className="appName__ad-example">
                        { secondApp.trackCensoredName }
                      </div>
                      
                      <div className="publisher__ad-example">
                        <span>
                          { secondApp.sellerName }
                        </span>
                      </div>
                    </div>
                    
                    <span className="getButton__ad-example">
                      { "GET" }
                    </span>
                  </div>
                  
                  <div className="screenshotsContainer__ad-example">
                    {
                      secondApp.screenshotUrls.slice(0, 3).map( (url, index)  =>
                        <div className="screenshot__ad-example" key={index}>
                          <img src={ url} alt={ "screen" }/>
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
    );
}
export default AdPreview;


// WEBPACK FOOTER //
// ./src/components/AdPreview/index.js